import React from "react";
import { TextField } from "@material-ui/core";
import styles from "./FeedbackText.module.scss";
import makeStyles from "@material-ui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: "20px",
    "& .MuiInputBase-input ": {
      border: "1px solid #BDBDBD",
      padding: "20px",
      borderRadius: "8px",
    },
  },
}));

const FeedbackText = ({
  inputID,
  inputText,
  updateFormData,
  onEnterKeyPress,
  placeHolder,
}) => {
  const classes = useStyles();
  return (
    <div className={styles.container}>
      <TextField
        className={classes.root}
        id={inputID}
        value={inputText}
        onChange={event => {
          const inputID = event.target.id;
          updateFormData({ inputID, [inputID]: event.target.value });
        }}
        onKeyDown={event => onEnterKeyPress(event)}
        InputProps={{ disableUnderline: true }}
        placeholder={placeHolder}
        multiline
        fullWidth
        minRows={5}
        maxRows={10}
      />
      <p className={styles.subtitle}>
        Press <span className={styles.bold}>ENTER</span> to submit
      </p>
    </div>
  );
};

export default FeedbackText;
